import React from 'react';
import { Footer, Header } from 'modules/ui';
import { PageLayout } from './styled';
import { ToastContainer } from './toastContainer/components';
import { SidePopout } from './sidePopout/components';
import { ScrollToTop } from './ScrollToTop';
import {Accessibility} from "../ui/accessability";

export const Layout: React.FC = ({ children }) => (
  <PageLayout flexDirection="column">
    <ScrollToTop />
    <Header />
    {children}
    <Accessibility />
    <Footer />
    <SidePopout />
    <ToastContainer />
  </PageLayout>
);
